import { type FC } from "react";
import { useNavigate } from "react-router";

import { ActionButton, ActionButtonIconPlacement, ActionButtonSize, VStack } from "widgets";

import { type Notification } from "../../graphql.js";
import { selMessage } from "../../messages/message.js";

export interface GroupNotificationProps {
  notification: Notification;
}

/**
 * A stateless component representing a group notification, currently very specific to groups of genomes created via NCBI agent.
 */
export const GroupNotification: FC<GroupNotificationProps> = ({ notification }) => {
  const navigate = useNavigate();
  const groupNotification = notification.groupNotification;

  if (groupNotification == null) {
    return null;
  }

  return (
    <VStack>
      <div>{groupNotification.description}</div>
      {groupNotification.group?.id && (
        <div>
          <ActionButton
            label={selMessage({
              id: "ncbiagent.execution.success",
              values: { genomesCount: groupNotification.group?.itemCount || 0 },
            })}
            onPress={() => navigate(`/group/${groupNotification.group?.id}`)}
            size={ActionButtonSize.Small}
            icon={"arrow_forward"}
            iconPlacement={ActionButtonIconPlacement.Right}
          />
        </div>
      )}
    </VStack>
  );
};
